// 2026 guidelines: thresholds represent 200%, 300%, 400%, 500%, 600% of FPG for the given household size
const costThresholds: { [key: number]: number[] } = {
  1: [31920, 47880, 63840, 79800, 95760],
  2: [43280, 64920, 86560, 108200, 129840],
  3: [54640, 81960, 109280, 136600, 163920],
  4: [66000, 99000, 132000, 165000, 198000],
  5: [77360, 116040, 154720, 193400, 232080],
  6: [88720, 133080, 177440, 221800, 266160],
  7: [100080, 150120, 200160, 250200, 300240],
  8: [111440, 167160, 222880, 278600, 334320],
  9: [122800, 184200, 245600, 307000, 368400],
  10: [134160, 201240, 268320, 335400, 402480],
  11: [145520, 218280, 291040, 363800, 436560],
  12: [156880, 235320, 313760, 392200, 470640],
  13: [168240, 252360, 336480, 420600, 504720],
  14: [179600, 269400, 359200, 449000, 538800],
  15: [190960, 286440, 381920, 477400, 572880],
  16: [202320, 303480, 404640, 505800, 606960],
  17: [213680, 320520, 427360, 534200, 641040],
  18: [225040, 337560, 450080, 562600, 675120],
  19: [236400, 354600, 472800, 591000, 709200],
  20: [247760, 371640, 495520, 619400, 743280],
};

const costTiers = [0, 99, 149, 199, 239];

export const getEstimatedCost = (householdSize: number, incomeStr: string | number): number | null => {
  const income = parseInt(incomeStr.toString().replace(/[^0-9]/g, ''), 10); // Remove $ and , and convert to number
  const thresholds = costThresholds[Math.min(20, householdSize)];

  if (income && thresholds) {
    for (let i = 0; i < thresholds.length; i++) {
      if (income <= thresholds[i]) {
        return costTiers[i];
      }
    }
  }

  return null;
};
